import {
  PRE_MUTATE_ROUTING_NUMBER_REGXP,
  PRE_MUTATE_ACCOUNT_NUMBER_REGXP,
} from '../../../constants/patterns';

export default function payoutCheckingPreMutate(formData, key, value) {
  switch (key) {
    case 'accountNumber':
      return PRE_MUTATE_ACCOUNT_NUMBER_REGXP.test(value);

    case 'routingNumber':
      return PRE_MUTATE_ROUTING_NUMBER_REGXP.test(value);

    default:
  }

  return true;
}
